import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SpinnerService } from './services/spinner.service';
import { MaterialModule } from './material.module';
import { SnakbarComponent } from './components/snakbar/snakbar.component';
import { SnakbarService } from './services/snakbar.service';
import { ModalService } from './services/modal.service';
import { LayoutModule } from './components/layout/layout.module';
import { AppBreadcrumbComponent } from './components/app-breadcrumb/app-breadcrumb.component';
import { AppDigitWithTwoDecimalNumberDirective } from './directives/digitsWithTwoDecimal.directive';
import { KeyStrokeDirectivesModule } from './directives/keystroke/keystrokes.module';
import { AddSymbolInputDirective } from './directives/addSymbol.directive';
import { AppAlphabetsWithNumbersDirective } from './directives/alphabetsWithNumbers.directive';
import { DateUtilService } from './utility/date-format';
import { AppNumbersWithHyphenDirective } from './directives/numbersWithHyphen.directive';
import { CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { SearchModule } from './components/search/search.module';
import { SearchOverlayService } from './services/search-overlay.service';
import { UppercaseDirective } from './directives/uppercase.directive';
import { AppCamelCaseDirective } from './directives/camelCase.directive';
import { AppValidAlphabetsDirective } from './directives/appValidAlphabets.directive';
import { AutoFocusDirective } from './directives/autoFocus.directive';
import { AppPhoneNumberDirective } from './directives/phoneNumber.directive';
import { OnOptionSelectedTabNewInputDirective } from './directives/onOptionSelectedTabNewInput.directive';
import { SessionStorageService } from './services/shared.service';
import { NumbersWithHyphenDirective } from './directives/hypen.directive';
import { NoTrailingSpaceDirective } from './directives/noTrailingSpace.directive';
import { AppPostalCodeDirective } from './directives/postalCode.directive';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorIntl } from './utility/customPaginatorIntl';
import { UnsavedChangesWarningDirective } from './directives/unsaved-changes-warning.directive';
import { ScannerInputDirective } from './directives/scanner.directive';
import { FocusClickOnTabDirective } from './directives/tab-focus-click.directive';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { TrimInputDirective } from './directives/trimEnd.directive';
import { DisableAutofillDirective } from './directives/disable-autofill.directive';
import { PhoneFormatDirective } from './directives/phone-format.directive';
import { DataTableComponent } from './components/data-table';
import { FieldClearSuffixComponent } from './components/field-clear-suffix';

@NgModule({
  declarations: [
    SnakbarComponent,
    AppDigitWithTwoDecimalNumberDirective,
    AddSymbolInputDirective,
    AppAlphabetsWithNumbersDirective,
    AppNumbersWithHyphenDirective,
    UppercaseDirective,
    AppCamelCaseDirective,
    AppValidAlphabetsDirective,
    AutoFocusDirective,
    AppPhoneNumberDirective,
    OnOptionSelectedTabNewInputDirective,
    NumbersWithHyphenDirective,
    NoTrailingSpaceDirective,
    AppPostalCodeDirective,
    ScannerInputDirective,
    FocusClickOnTabDirective,
    DisableAutofillDirective,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    AppBreadcrumbComponent,
    KeyStrokeDirectivesModule,
    DatePipe,
    CdkDropList,
    CdkDrag,
    SearchModule,

    UnsavedChangesWarningDirective,
    DateTimePickerComponent,
    TrimInputDirective,
    PhoneFormatDirective,
    DataTableComponent,
    FieldClearSuffixComponent,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    LayoutModule,
    AppBreadcrumbComponent,
    AppDigitWithTwoDecimalNumberDirective,
    KeyStrokeDirectivesModule,
    AddSymbolInputDirective,
    AppAlphabetsWithNumbersDirective,
    AppNumbersWithHyphenDirective,
    CdkDropList,
    CdkDrag,
    SearchModule,
    UppercaseDirective,
    AppCamelCaseDirective,
    AppValidAlphabetsDirective,
    AutoFocusDirective,
    AppPhoneNumberDirective,
    OnOptionSelectedTabNewInputDirective,
    NumbersWithHyphenDirective,
    NoTrailingSpaceDirective,
    AppPostalCodeDirective,
    UnsavedChangesWarningDirective,
    ScannerInputDirective,
    FocusClickOnTabDirective,
    DateTimePickerComponent,
    TrimInputDirective,
    DisableAutofillDirective,
    PhoneFormatDirective,
    DataTableComponent,
    FieldClearSuffixComponent,
  ],
  providers: [
    SpinnerService,
    SnakbarService,
    ModalService,
    DateUtilService,
    DatePipe,
    SearchOverlayService,
    SessionStorageService,
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
  ],
})
export class SharedModule {}
